var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18790_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 55.9997C24.0002 57.333 25.0668 58.6663 26.6668 58.6663H37.3335C38.9335 58.6663 40.0002 57.333 40.0002 55.9997V53.333H24.0002V55.9997ZM32.0002 5.33301C21.6002 5.33301 13.3335 13.5997 13.3335 23.9997C13.3335 30.3997 16.5335 35.9997 21.3335 39.1997V45.333C21.3335 46.6663 22.4002 47.9997 24.0002 47.9997H40.0002C41.6002 47.9997 42.6668 46.6663 42.6668 45.333V39.1997C47.4668 35.733 50.6668 30.133 50.6668 23.9997C50.6668 13.5997 42.4002 5.33301 32.0002 5.33301Z",
    fill: "#FFA747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18790_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.706a34d744fda7f5687b3c2641e3afcd.svg";
export { ForwardRef as ReactComponent };